module.exports = __webpack_public_path__ + "img/img18.72dd8ce6.jpg";